import React from 'react';

// Material-UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';


import {
  RequestNote
} from '../../models';

interface NotesMobileProps {
  rows: Array<RequestNote>;
}

const NotesMobile: React.FC<NotesMobileProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      margin: theme.spacing(1, 0, 0, 0),
    },
    note: {
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1, 0, 1, 0)
    }
  };

  // #endregion

  // #region Methods

  /*
  * Render the set of notes for the date range
  */
  const renderNotes = () => {

    if (props.rows.length === 0) {
      return (
        <Typography>No notes for the selected dates</Typography>
      );
    } else {
      return (
        props.rows.map(r => renderNote(r))
      );
    }

  }

  /*
  * Render the contents of a single note
  */
  const renderNote = (n: RequestNote) => {
    return (
      <Box sx={styles.note}>
        <Typography gutterBottom>{n.createdBy}: {n.referenceNumber}</Typography>
        <Typography variant="body2">Updated: {n.updated}</Typography>
        <Typography variant="body2">{n.minArrivalDate}-{n.maxDepartureDate}</Typography>
        <Typography variant="body2" gutterBottom>Group Size: {n.groupSize} Nights: {n.nights}</Typography>
        <Typography variant="body2">{n.notes}</Typography>
      </Box>
    );
  }

  // #endregion

  return (
    <Box sx={styles.root}>
      {renderNotes()}
    </Box>
  );

}

export default NotesMobile;